import React from 'react';
import { Tag } from 'antd';
import {
  CheckCircleOutlined,
  ClockCircleOutlined,
  SyncOutlined,
  ExclamationCircleOutlined,
  WarningOutlined,
  ArrowUpOutlined
} from '@ant-design/icons';

interface FixedStatusTagProps {
  status: string | undefined;
}

const FixedStatusTag: React.FC<FixedStatusTagProps> = ({ status }) => {
  // Define status configurations with colors and icons only
  const statusConfig: Record<string, { color: string; icon: React.ReactNode; text?: string }> = {
    'Detected': {
      color: 'blue',
      icon: <ClockCircleOutlined />
    },
    'Received': {
      color: 'blue',
      icon: <ClockCircleOutlined />
    },
    'TopUpNeeded': {
      color: 'orange',
      icon: <ArrowUpOutlined />
    },
    'TopUpPending': {
      color: 'gold',
      icon: <SyncOutlined spin />
    },
    'Confirmed': {
      color: 'cyan',
      icon: <CheckCircleOutlined />
    },
    'Processing': {
      color: 'geekblue',
      icon: <SyncOutlined spin />
    },
    'Completed': {
      color: 'green',
      icon: <CheckCircleOutlined />
    },
    'Failed': {
      color: 'red',
      icon: <ExclamationCircleOutlined />
    },
    'default': {
      color: 'default',
      icon: <WarningOutlined />
    }
  };

  // Handle undefined status
  if (!status) {
    return (
      <Tag color="default" icon={<WarningOutlined />}>
        Unknown
      </Tag>
    );
  }

  // Get config for current status or use default
  const config = statusConfig[status] || statusConfig.default;

  // Return the tag without any tooltip
  return (
    <Tag color={config.color} icon={config.icon}>
      {config.text || status}
    </Tag>
  );
};

export default FixedStatusTag;
